__turbopack_context__.v({
  "aboutContainer": "about-module-scss-module__w-VLCa__aboutContainer",
});
